import React from 'react';
import "./selectImage.css"
import logoIcon from "../../../assets/img/motor.png";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const SelectImage = ({onChange,item}) => {
    return (
        <div className={"selectImage"}>
            <FormControlLabel
                control={
                    <Checkbox
                        name="sending_data"
                        color="primary"
                        value={item.id}
                        onChange={() => onChange(item.id)}
                    />
                }
            />
            <img width="100" src={`https://laapi.bimic.ir/storage/${item.directory}/${item.file}`}/>
        </div>
    );
};

export default SelectImage;
